import { Box, Grid, Typography } from '@mui/material';
import { FormTab, FormTabProps } from 'react-admin';
import { CraftPageSection } from 'src/components/CraftPageSection';
import TextInput from 'src/inputs/TextInput';
import { usePassportScopes } from '../usePassportScopes';

const TITLE = 'Scope Mapping';

const PassportScopeMapping = (props: Omit<FormTabProps, 'label'>) => {
  const { scopeKeys } = usePassportScopes();

  return (
    <FormTab label={TITLE} {...props}>
      <CraftPageSection title={TITLE}>
        {scopeKeys.map((scopeKey) => (
          <Grid container key={scopeKey} spacing={2} sx={{ mb: 2, pr: 2 }}>
            <Grid item xs={12} md={3}>
              <Box sx={{ pt: 1 }}>
                <Typography variant="body2" fontWeight={500}>
                  {scopeKey}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={9}>
              <TextInput source={`scopeLabels.${scopeKey}.displayLabel`} label="Custom Label" size="small" fullWidth />
              <TextInput
                source={`scopeLabels.${scopeKey}.displayDescription`}
                label="Custom Description"
                size="small"
                multiline
                rows={2}
                fullWidth
              />
            </Grid>
          </Grid>
        ))}
      </CraftPageSection>
    </FormTab>
  );
};

export default PassportScopeMapping;
